var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPlaceholderFileLines = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 59.875,
    height: 71.626,
    viewBox: "0 0 59.875 71.626",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_142",
    "data-name": "Path 142",
    d: "M775.077-36.821h-7.834v-7.834a2.8,2.8,0,0,0-2.8-2.8H720.8a2.8,2.8,0,0,0-2.8,2.8v55.4a2.8,2.8,0,0,0,2.8,2.8h7.834v7.834s0,0,0,0a2.8,2.8,0,0,0,2.817,2.793h43.628a2.8,2.8,0,0,0,2.8-2.8v-55.4A2.8,2.8,0,0,0,775.077-36.821ZM723.6,7.945v-49.8h38.051v49.8Zm48.683,10.632H749.246l16.021-5.16a2.814,2.814,0,0,0,1.976-2.712V-31.225h5.036ZM756.611-30.806a2.8,2.8,0,0,1-2.8,2.8H731.43a2.8,2.8,0,0,1-2.8-2.8,2.8,2.8,0,0,1,2.8-2.8h22.383A2.8,2.8,0,0,1,756.611-30.806Zm0,13.85a2.8,2.8,0,0,1-2.8,2.8H731.43a2.8,2.8,0,0,1-2.8-2.8,2.8,2.8,0,0,1,2.8-2.8h22.383A2.8,2.8,0,0,1,756.611-16.956Zm0,13.85a2.8,2.8,0,0,1-2.8,2.8H731.43a2.8,2.8,0,0,1-2.8-2.8,2.8,2.8,0,0,1,2.8-2.8h22.383A2.8,2.8,0,0,1,756.611-3.107Z",
    transform: "translate(-718 47.453)",
    fill: "#e3e3e3"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPlaceholderFileLines);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/placeholder_file-lines.ba5d8e46de0ae4f5a4e321a59d32d510.svg";